import { buildThemeAliases } from "src/legacy/utils"
import { base } from "./base"

export const inputAliases = buildThemeAliases(base, {
  gutterX: "10",
  gutterXInline: "35",
})

export type InputAliases = Record<keyof typeof inputAliases, string>
